import { render, staticRenderFns } from "./OrdersSelectActions.vue?vue&type=template&id=a763414e"
import script from "./OrdersSelectActions.vue?vue&type=script&lang=js"
export * from "./OrdersSelectActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports